// src/pages/DigitalMarketing.tsx
import React from 'react';
import { Link } from 'react-router-dom';
import SEO from "../components/SEO";
import { seoConfig } from "../seoConfig";

import GetInTouch from '../components/GetInTouch';

import { useImageParallax } from "../hooks/useImageParallax";

import digital from '../assets/images/services/digital.webp';

const DigitalMarketing: React.FC = () => {

const seo = seoConfig.digitalMarketing; // ✅ Load meta for this page

useImageParallax(".anim-image-parallax"); // hook call


  return (


<>


      <SEO
        title={seo.title}
        description={seo.description}
        keywords={seo.keywords}
        url={seo.url}
        image={seo.image}
      />



  {/* rts bread crumba rea start */}
  <div className="rts-breadcrumb-area-digital bg_image">
    <div className="container">
      <div className="row">
        <div className="col-lg-12">
          <div className="baread-crumb-main-wrapper pt--100">
            <div className="inner">
              <h1 className="title rts_hero__title">Digital Marketing</h1>
              <span className="bg-text d-none d-md-inline">Manikarn Digital</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  {/* rts bread crumba rea end */}



  {/* rts about area three */}
  <div
    className="rts-about-area parallax-about pt_sm--0 pb--80"
    id="about"
  >
    <div className="container">
      <div className="row g-5 align-items-center">
        <div className="col-lg-5">
          <a href="about.html" className="pli-image-link">
            <div className="pli-image-holder">
              {/* Use class "cover-opacity-*" to set image overlay if needed. For example "cover-opacity-2". Useful if class "pli-info-overlay" is enabled on "portfolio-list". Note: It is individual and depends on the image you use. More info about helper classes in file "helper.css". */}
              <figure className="pli-image">
                <img
                  className="anim-image-parallax tt-lazy"
                  src={digital}
                  data-src={digital}
                  alt="image"
                />
              </figure>{" "}
              {/* /.pli-image */}
            </div>{" "}
            {/* /.pli-image-holder */}
          </a>{" "}
          {/* /.pli-image-link */}
        </div>
        <div className="col-lg-7">

  <div className="content-wrapper">
    <span className="sub-title">MANIKARN DIGITAL</span>
    <h2 className="title mt--15 mb--20 mt_sm--10 mb_sm--10">
      Boost Visibility, Traffic & Sales Online
    </h2>
    <p className="disc">
      At  <strong>Manikarn Digital</strong>, we help your brand shine online through customized Digital Marketing strategies that drive visibility, engagement, and growth. Our comprehensive approach combines creativity, data, and industry best practices to ensure your business connects with the right audience—at the right time.
    </p>
    <Link to="/contact" className="learn-more-btn mt--30">
      Contact Us <i className="fa-solid fa-arrow-up-right-from-square"></i>
    </Link>
  </div>


        </div>
      </div>
    </div>
  </div>
  {/* rts about area three end */}

    {/* service area start */}
  <div className="rts-servicearea-start pt_sm--0 pb--100 pb_sm--20">
    <div className="container">
      <div className="row mb--10">
        <div className="col-lg-10 mx-auto">

  <div className="content-wrapper text-center">
    <span className="sub-title">MANIKARN DIGITAL</span>
    <h2 className="title mt--15 mb--20 mt_sm--10 mb_sm--10">
      Our Expertise, Your Advantage
    </h2>
  </div>


        </div>
      </div>
      <div className="row g-2">
        <div className="col-lg-3 col-md-6 col-sm-12 col-12">
          {/* single service area start */}
          <div className="single-service-style-seven">
            <div className="icon">

<svg width="80" height="80" viewBox="0 0 24 24" fill="none" stroke="#ffffff" stroke-width="1" stroke-linecap="round" stroke-linejoin="round">
  <circle cx="12" cy="12" r="2">
    <animate attributeName="r" values="2;4;2" dur="4s" repeatCount="indefinite"/>
  </circle>
  <path d="M2 12a10 10 0 0 1 20 0">
    <animate attributeName="stroke-dasharray" values="0,50;50,0;0,50" dur="4s" repeatCount="indefinite"/>
  </path>
</svg>



            </div>
            <h5 className="title-1">
              Multi-Channel Campaigns
            </h5>
            <p className="disc">
              We leverage a powerful mix of SEO, social media marketing, email campaigns, and paid advertising to reach your audience on the platforms they frequent most, driving meaningful engagement and sustainable growth.
            </p>
          </div>
          {/* single service area end */}
        </div>
        <div className="col-lg-3 col-md-6 col-sm-12 col-12">
          {/* single service area start */}
          <div className="single-service-style-seven">
            <div className="icon">

<svg width="80" height="80" viewBox="0 0 24 24" fill="none" stroke="#ffffff" stroke-width="1" stroke-linecap="round" stroke-linejoin="round">
  <polyline points="3 17 9 11 13 15 21 7">
    <animate attributeName="stroke-dasharray" values="0,40;40,0;0,40" dur="4s" repeatCount="indefinite"/>
  </polyline>
  <polyline points="14 7 21 7 21 14"></polyline>
</svg>


            </div>
            <h5 className="title-1">
              ROI-Oriented Strategies
            </h5>
            <p className="disc">
              Every campaign is built around measurable outcomes—whether it’s increasing website traffic, generating leads, or boosting conversions. We continuously optimize performance using data-driven insights
            </p>

          </div>
          {/* single service area end */}
        </div>
        <div className="col-lg-3 col-md-6 col-sm-12 col-12">
          {/* single service area start */}
          <div className="single-service-style-seven">
            <div className="icon">


<svg width="80" height="80" viewBox="0 0 24 24" fill="none" stroke="#ffffff" stroke-width="1" stroke-linecap="round" stroke-linejoin="round">
  <rect x="4" y="3" width="16" height="18" rx="2" ry="2"/>
  <line x1="8" y1="9" x2="16" y2="9">
    <animate attributeName="x2" values="8;16;8" dur="4s" repeatCount="indefinite"/>
  </line>
  <line x1="8" y1="13" x2="14" y2="13">
    <animate attributeName="x2" values="8;14;8" dur="4s" repeatCount="indefinite"/>
  </line>
</svg>



            </div>
            <h5 className="title-1">
              Content That Converts
            </h5>
            <p className="disc">
              Our team crafts engaging, relevant content—from blog posts and social updates to email newsletters—that builds trust and drives action. We pair strong messaging with SEO to grow organic visibility alongside engagement
            </p>
          </div>
          {/* single service area end */}
        </div>
                <div className="col-lg-3 col-md-6 col-sm-12 col-12">
          {/* single service area start */}
          <div className="single-service-style-seven">
            <div className="icon">


<svg width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
  <rect x="10" y="40" width="12" height="30" fill="#ffffff">
    <animate attributeName="height" from="0" to="30" dur="4s" repeatCount="indefinite" values="0;30;15;30" keyTimes="0;0.3;0.6;1"/>
    <animate attributeName="y" from="70" to="40" dur="4s" repeatCount="indefinite" values="70;40;55;40" keyTimes="0;0.3;0.6;1"/>
  </rect>
  <rect x="34" y="20" width="12" height="50" fill="#ffffff">
    <animate attributeName="height" from="0" to="50" dur="4.2s" repeatCount="indefinite" values="0;50;25;50" keyTimes="0;0.3;0.6;1"/>
    <animate attributeName="y" from="70" to="20" dur="4.2s" repeatCount="indefinite" values="70;20;45;20" keyTimes="0;0.3;0.6;1"/>
  </rect>
  <rect x="58" y="30" width="12" height="40" fill="#ffffff">
    <animate attributeName="height" from="0" to="40" dur="4.4s" repeatCount="indefinite" values="0;40;20;40" keyTimes="0;0.3;0.6;1"/>
    <animate attributeName="y" from="70" to="30" dur="4.4s" repeatCount="indefinite" values="70;30;50;30" keyTimes="0;0.3;0.6;1"/>
  </rect>
</svg>



            </div>
            <h5 className="title-1">
              Results with Analytics
            </h5>
            <p className="disc">
              We track campaign metrics across tools like Google Analytics, Search Console, and social insights to refine our tactics, optimize performance, and deliver better ROI—ensuring transparency and measurable results, always.
            </p>
          </div>
          {/* single service area end */}
        </div>
      </div>
    </div>
  </div>
  {/* service area ends */}

{/* ==== GetInTouch Section start ==== */}
<GetInTouch />
{/* ==== / GetInTouch Section end ==== */}  


</>


  );
};

export default DigitalMarketing;
